/**
 * @author gyb(mocheer)
 * @since 2017.5.20
 */
let { isArray } = T;
let { latLng } = L;
/**
 * @param coords 支持的格式:
 * 一维：
 * {lat,lng}
 * {lon,lat}
 * [lon,lat]
 * 二维：
 * [[lon,lat],[lon,lat]...]
 * [{lon,lat},{lon,lat}...]
 * [{lat,lng},{lon,lng}...]
 * 多维：
 * ...
 */
export default function lonlats(coords, deep) {
  return (deep-- && coords.map(item => lonlats(item, deep)))
    || (isArray(coords) && latLng(coords[1], coords[0]))
    || latLng(coords);
}



// WEBPACK FOOTER //
// ./src/utils/LonLats.js